import isEmpty from 'lodash/isEmpty';

/**
 * @description
 * A slot is booked if it contains an appointment
 */
export function isSlotBooked(slot) {
  return !isEmpty(slot._appointment);
}
